import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { SelectMenu } from 'components';

const useStyles = makeStyles((theme) => ({
  selectWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: theme.spacing(5.5), // 44px
    marginTop: theme.spacing(5.5),

    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      maxWidth: '100%',
    },
  },
  select: {
    maxWidth: theme.spacing(42.875),
    width: '100%',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#767676',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
  },
}));

const selectInputStyles = {
  padding: '12px 24px 12px 14px',
  margin: 0,
};

const styleInputLabel = {
  lineHeight: 1,
  padding: '4px',
};

const TTSVoiceControl = ({
  onVoiceChange,
  currentVoice,
  voices = [],
  lastFocusableRef,
  onLastElementKeyDown,
  ...props
}) => {
  const classes = useStyles();

  return (
    <div className={classes.selectWrapper} {...props}>
      <div className={classes.select}>
        <SelectMenu
          label="voice"
          onChange={onVoiceChange}
          optionProps={{ className: 'noTranslate' }}
          SELECT_OPTIONS={voices}
          stylePropsSelect={selectInputStyles}
          stylePropsLabel={styleInputLabel}
          value={currentVoice}
          selectInputProps={{
            ref: lastFocusableRef,
            onKeyDown: onLastElementKeyDown,
          }}
        />
      </div>
    </div>
  );
};

TTSVoiceControl.propTypes = {
  onVoiceChange: PropTypes.func,
  currentVoice: PropTypes.string,
  voices: PropTypes.array,
  lastFocusableRef: PropTypes.object,
  onLastElementKeyDown: PropTypes.func,
};

export default TTSVoiceControl;
